import { ReactComponent as ExclamationCircleFillSVG } from 'assets/icons/exclamationCircleFill.svg';
import { useTranslation } from 'react-i18next';
import { Overlay } from './PermissionWarningStyle';

type PermissionWarningProps = {
  show?: boolean;
};

export const PermissionWarning = ({ show }: PermissionWarningProps) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <Overlay role="alert">
      <ExclamationCircleFillSVG />
      <p>{t('permissions.cameraDenied')}</p>
    </Overlay>
  );
};
